import config from 'config';

const domains = {
  BOTICARIO: 'boticario.com.br',
  EUAMOMAKE: 'quemdisseberenice.com.br',
  OUI: 'ouiparis.com',
  EUDORA: 'eudora.com.br',
  EUD: 'eudora.com.br',
} as { [key: string]: string };

export const generateReMLDLink = (resellerId: string, brand: string) =>
  `https://minhaloja.${domains[brand]}/redirect/${resellerId}/?origin=${config.app.slugname}`;
